import type { ReactNode } from 'react'

import NumberAnimation from 'components/NumberAnimation'
import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

const titlesRecord = {
  GC: 'Gold Coins',
  SC: 'Sweepstakes Coins',
}

type Props = {
  currency: SupportedCurrencies
  amount: number
  children?: ReactNode
  tooltip?: ReactNode
  showSign?: boolean
}

export default function CurrencyDescriptionItem(props: Props) {
  const { currency, amount } = props
  const iconsRecord = {
    GC: (
      <img src={`${process.env.IMG_ORIGIN}/coin-icon.svg`} className={classes.icon} width={14} height={16} alt='GC' />
    ),
    SC: <img src={`${process.env.IMG_ORIGIN}/sc-icon.png`} className={classes.icon} width={16} height={16} alt='SC' />,
  }

  return (
    <div className={classes.item}>
      <span className={`mt-typography-subtitle2 ${classes.itemText}`}>
        {titlesRecord[currency]}
        {props?.children}
        {props?.tooltip}
      </span>
      <span className={`mt-typography-subtitle2 ${classes.itemText}`}>
        {typeof amount === 'number' && (
          <>
            {iconsRecord[currency]}
            {props.showSign && `${currency} `}

            <NumberAnimation amount={amount} currency={currency} />
          </>
        )}
      </span>
    </div>
  )
}
